import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash.get';
import { Box, FormDialog, Grid, InputField } from '@kis-technologies/kis-ui';
import { selectors as configSelectors } from 'store/configurations';
import { useStyles } from '../styled';
import { TransitionTimeOverlayProps } from '../types';

const TransitionTimeOverlay = (props: TransitionTimeOverlayProps) => {
  const { configuration, onClose, onSave } = props;
  const { configuration: configColumn } = configuration;

  const globalSettings = get(configColumn, 'globalSettings');
  const attractLoop = get(globalSettings, 'attractLoop');
  const transitionTime = get(attractLoop, 'transitionTime', 5);

  const { pending } = useSelector(configSelectors.selectAction);

  const [transitionTimeSec, setTransitionTime] = useState<number>(transitionTime);
  const [transitionTimeError, setTransitionTimeError] = useState<string | null>(null);
  const isConfirmDisabled = Boolean(!transitionTimeSec || transitionTimeSec === transitionTime);

  const classes = useStyles({ genreTab: false })();

  const onTransitionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    setTransitionTimeError(null);
    if (Number(value) >= 1 && Number(value) <= 10) {
      setTransitionTime(Number(value) || 0);
    } else {
      setTransitionTimeError('Transition time must be between 1 and 10 seconds');
    }
  };

  return (
    <FormDialog
      cancelButtonAction={onClose}
      cancelButtonText="Cancel"
      confirmButtonAction={() => onSave({ transitionTime: transitionTimeSec })}
      confirmButtonDisabled={isConfirmDisabled}
      confirmButtonIsLoading={pending}
      confirmButtonText="Save"
      open
      title="Slide Transition Time"
    >
      <Grid>
        <Box className={classes.overlayFieldBox}>
          <InputField
            align="center"
            autoFocus
            data-testid="transition-input"
            error={transitionTimeError !== null}
            helperText={transitionTimeError}
            label="Slide Transition Time"
            onChange={onTransitionChange}
            size="small"
            sx={{ width: '262px' }}
            type="number"
            value={transitionTimeSec}
          />
        </Box>
      </Grid>
    </FormDialog>
  );
};

export default TransitionTimeOverlay;
